import Footer from "../components/Footer";

export default function About() {
  return (
    <div className="flex min-h-screen flex-col">
      <main className="flex-1 p-6">
        <h1 className="text-2xl font-bold">À propos</h1>
        <p className="mt-2 max-w-3xl text-text">
          DawaRedacc aide les équipes Marketing et Produit à produire des contenus SEO
          performants depuis le navigateur, avec un pipeline guidé et mesurable
          (Plan → Meta → Brouillon → Score → Publication).
        </p>
        <div className="mt-6 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          <div className="rounded border p-4">
            <h2 className="font-semibold">Notre mission</h2>
            <p className="mt-1 text-sm text-muted">
              Accélérer la production de contenus de qualité sans sacrifier l’exigence
              éditoriale ni la conformité SEO.
            </p>
          </div>
          <div className="rounded border p-4">
            <h2 className="font-semibold">Comment ça marche</h2>
            <ul className="mt-1 list-disc pl-4 text-sm text-muted space-y-1">
              <li>Créez un contenu à partir d’un playbook.</li>
              <li>Générez les étapes clés en 1 clic, avec estimation crédits/ETA.</li>
              <li>Révisez avec le Copilot et visualisez les diffs.</li>
              <li>Publiez ou exportez (Markdown/HTML).</li>
            </ul>
          </div>
          <div className="rounded border p-4">
            <h2 className="font-semibold">Pour qui</h2>
            <p className="mt-1 text-sm text-muted">
              B2B SaaS, e‑commerce, équipes éditoriales, agences SEO.
            </p>
          </div>
        </div>
        <div className="mt-6 rounded border p-4 max-w-3xl">
          <h2 className="font-semibold">Contact</h2>
          <p className="mt-1 text-sm text-muted">
            Une question ? Écrivez‑nous via la page Contact, nous répondons sous 24h.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
